import React from "react";
import { Div } from "atomize";
import PrimaryButton from "./PrimaryButton";

const SolutionsPagesButton = ({ bgColor, textColor, hoverBgPrimary }) => {
  return (
    <>
      <Div
        // m={{ t: "2.125rem" }}
        d={{ md: "flex" }}
        align="center"
        className="hero-swiper-content"
      >
        <Div>
          <PrimaryButton
            className="hero-action-btn"
            fontFamily="primary"
            bg={bgColor}
            hoverBg={hoverBgPrimary ? hoverBgPrimary : "#353535"}
            textTransform="none"
            textColor={textColor}
            fontFamily="primary"
            h="3.125rem"
            border="none"
            p="0 1.25rem"
            w="100%"
            textWeight="800"
            onClick={
              () => (window.location.href = "https://trend.io/pricing")
              // hero.hero.heroBtnPrimary.link)
            }
          >
            {/* {hero.hero.heroBtnPrimary.text} */}
            Start a Free Campaign
          </PrimaryButton>
        </Div>
        <Div>
          <PrimaryButton
            className="hero-action-btn secondary"
            bg="white"
            hoverBg="lightGray"
            w="100%"
            fontFamily="primary"
            h="3.125rem"
            textColor="black"
            textWeight="800"
            textTransform="none"
            border="none"
            onClick={
              () => (window.location.href = "https://trend.io/product-tour")
              // hero.hero.heroBtnSecondary.link
            }
          >
            {/* {hero.hero.heroBtnSecondary.text} */}
            Watch Live Demo
          </PrimaryButton>
        </Div>
      </Div>
    </>
  );
};

export default SolutionsPagesButton;
